let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3sl1f")).then(() => parcelRequire('4QaSh'));